import React, { useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
import { CircularProgress } from '@mui/material';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API;

const HSNWiseSummary = ({ fromDate, toDate, companyCode, yearCode }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isDataFetched, setIsDataFetched] = useState(false);

    const fetchHSNWiseSummary = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await axios.get(`${API_URL}/HSNWise-summary`, {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                    Company_Code: companyCode,
                    Year_Code: yearCode,
                },
            });
            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found.!',
                    text: 'No HSNWISE data found for the selected date range.',
                });
                return;
            }
            setData(response.data);
            setIsDataFetched(true);
            openInNewWindow(response.data);
        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const openInNewWindow = (data) => {
        const newWindow = window.open('', '_blank');
        if (!newWindow) return;

        const columns = [
            'HSN',
            'Quantal',
            'TaxableAmount',
            'CGST',
            'SGST',
            'IGST',
            'TCSAmt',
            'TDSAMT',
            'NetPayable',
        ];

        const totals = calculateTotals(data);

        const exportXlsxScript = `
        function exportToXlsx() {
            const data = ${JSON.stringify(data)};
            const columnOrder = ['HSN','Quantal','TaxableAmount','CgstAmt','SgstAmt','IgstAmt','TCSAmt','TDSAMT','NetPayable'];
            const formattedData = data.map(row => {
                return {
                    ...row,
                    TaxableAmount: parseFloat(row.TaxableAmount) || 0,
                    CgstAmt: parseFloat(row.CgstAmt) || 0,
                    SgstAmt: parseFloat(row.SgstAmt) || 0,
                    IgstAmt: parseFloat(row.IgstAmt) || 0,
                    TCSAmt: parseFloat(row.TCSAmt) || 0,
                    TDSAMT: parseFloat(row.TDSAMT) || 0,
                    NetPayable: parseFloat(row.NetPayable) || 0,
                };
            });
    
            const ws = XLSX.utils.json_to_sheet(formattedData, { header: columnOrder, skipHeader: false });
            
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                const TaxableAmountCell = ws[XLSX.utils.encode_cell({ r: row, c: 7 })];
                const CgstAmtCell = ws[XLSX.utils.encode_cell({ r: row, c: 8 })]; 
                const SgstAmtCell = ws[XLSX.utils.encode_cell({ r: row, c: 9 })]; 
                const IgstAmtCell = ws[XLSX.utils.encode_cell({ r: row, c: 10 })]; 
                const TCSAmtCell = ws[XLSX.utils.encode_cell({ r: row, c: 11 })]; 
                const TDSAMTCell = ws[XLSX.utils.encode_cell({ r: row, c: 12 })]; 
                const NetPayableCell = ws[XLSX.utils.encode_cell({ r: row, c: 13 })]; 

                if (TaxableAmountCell) TaxableAmountCell.z = '0.00';
                if (CgstAmtCell) CgstAmtCell.z = '0.00';
                if (SgstAmtCell) SgstAmtCell.z = '0.00';
                if (IgstAmtCell) IgstAmtCell.z = '0.00';
                if (TCSAmtCell) TCSAmtCell.z = '0.00';
                if (TDSAMTCell) TDSAMTCell.z = '0.00';
                if (NetPayableCell) NetPayableCell.z = '0.00';
            }
            
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SaleTCSData");
            const xlsx = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([xlsx], { type: "application/octet-stream" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "HSNWiseSummary.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    `;

        newWindow.document.write(`
            <html>
                <head>
                    <title>HSN Wise Summary</title>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
                      <script>${exportXlsxScript}</script>
                    <style>
                    body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
                    h2 { text-align: center; margin-top: 0; }
                    .table-container {
                        max-height: 500px;
                        overflow-y: auto;
                        margin: 20px auto;
                        width: 90%;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 6px 8px;
                        text-align: left;
                        white-space: nowrap;
                    }
                    th {
                        background-color:rgb(206, 200, 243);
                        position: sticky;
                        top: 0;
                        z-index: 2;
                        font-weight: bold;
                        font-size: 20px;
                        height: 50px;
                        text-align: center;
                    }
                    .export-btn {
                        padding: 10px 20px;
                        font-size: 16px;
                        background-color: green;
                        color: white;
                        border: none;
                        cursor: pointer;
                        margin-bottom: 20px;
                        margin-top: 20px;
                    }
                    .total-row {
                        background-color: yellow;
                        font-weight: bold;
                    }
                </style>
                </head>
                <body>
                    <h2>HSN Wise Summary Report</h2>
                    <button class="export-btn" onclick="window.exportToXlsx()">Export to XLSX</button>
                    <table>
                        <thead>
                            <tr style="text-align: right;">
                                ${columns.map((column) => `<th style="text-align: center;">${column}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${data.map(row => {
            return `  
                                    <tr>
                                        <td style="text-align: center;">${row.HSN}</td>
                                        <td style="text-align: right;">${formatReadableAmount(row.Quantal || '')}</td>
                                        <td style="text-align: right;">${formatReadableAmount(row.TaxableAmount || '')}</td> 
                                        <td style="text-align: right;">${formatReadableAmount(row.CgstAmt || '')}</td>
                                        <td style="text-align: right;">${formatReadableAmount(row.SgstAmt || '')}</td> 
                                        <td style="text-align: right;">${formatReadableAmount(row.IgstAmt || '')}</td>
                                        <td style="text-align: right;">${formatReadableAmount(row.TCSAmt || '')}</td>
                                        <td style="text-align: right;">${formatReadableAmount(row.TDSAMT || '')}</td>

                                        <td style="text-align: right;">${formatReadableAmount(row.NetPayable || '')}</td>
                                    </tr>
                                `;
        }).join('')}
                        </tbody>
                        <tfoot>
                            <tr class="total-row">
                                <td>Total</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.Quantal.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.TaxableAmount.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.CgstAmt.toFixed(2))}</td> 
                                <td style="text-align: right;">${formatReadableAmount(totals.SgstAmt.toFixed(2))}</td> 
                                <td style="text-align: right;">${formatReadableAmount(totals.IgstAmt.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.TCSAmt.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.TDSAMT.toFixed(2))}</td>

                                <td style="text-align: right;">${formatReadableAmount(totals.NetPayable.toFixed(2))}</td>
                            </tr>
                        </tfoot>
                    </table>
                   
                </body>
            </html>
        `);

        newWindow.document.close();
    };

    const calculateTotals = (data) => {
        let totals = {
            Quantal: 0,
            TaxableAmount: 0,
            CgstAmt: 0,
            SgstAmt: 0,
            IgstAmt: 0,
            TCSAmt: 0,
            NetPayable: 0,
            TDSAMT: 0
        };

        data.forEach(row => {
            totals.TaxableAmount += parseFloat(row.TaxableAmount || 0);
            totals.CgstAmt += parseFloat(row.CgstAmt || 0);
            totals.SgstAmt += parseFloat(row.SgstAmt || 0);
            totals.IgstAmt += parseFloat(row.IgstAmt || 0);
            totals.TCSAmt += parseFloat(row.TCSAmt || 0);
            totals.NetPayable += parseFloat(row.NetPayable || 0);
            totals.Quantal += parseFloat(row.Quantal || 0);
            totals.TDSAMT += parseFloat(row.TDSAMT || 0);

        });
        return totals;
    };

    return (
        <div className="d-flex flex-column align-items-center" style={{ marginTop: '5px' }}>
            <button
                variant="contained"
                color="primary"
                onClick={fetchHSNWiseSummary}
                disabled={loading}
                style={{
                    width: '20%',
                    height: '60px',
                }}
            >
                {loading ? <CircularProgress size={24} /> : 'HSNWise Summary'}
            </button>

            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default HSNWiseSummary;
